module.exports = __webpack_public_path__ + "8abf331419822c547f5d54ffd2b2221b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/azzad_fund.png
// module id = 1628
// module chunks = 0